"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderClient = void 0;
var MockClient_1 = require("./MockClient");
var Client_1 = require("./Client");
var useMock_1 = __importDefault(require("../util/useMock"));
exports.OrderClient = {
    submitOrder: function (order) { return useMock_1.default() ? MockClient_1.MockOrderClient.submitOrder(order) : Client_1.OrderClient.submitOrder(order); },
    getOrdersForLocation: function (locationId, authToken, activeOrdersOnly) {
        return useMock_1.default() ? MockClient_1.MockOrderClient.getOrdersForLocation(locationId, authToken) : Client_1.OrderClient.getOrdersForLocation(locationId, authToken, activeOrdersOnly);
    },
    cancelOrder: function (locationId, orderId, authToken) { return useMock_1.default() ? MockClient_1.MockOrderClient.cancelOrder() : Client_1.OrderClient.cancelOrder(locationId, orderId, authToken); },
    setBaseUrl: function (url) { return Client_1.OrderClient.setBaseUrl(url); }
};
